import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { formatDateWithLocale, calculateDurationInDays, sanitizeHTML } from '../../shared/utils';
import '../InfoTab.css';

const PrintHeader = ({ planData }) => {
  const { t } = useTranslation();
  const { name, description, startDate, endDate, groupInfo = {}, destination } = planData || {};
  
  // Calculate days count using utility function
  const getDuration = () => {
    if (!startDate || !endDate) return t('planDetail.print.notSpecified');
    
    const days = calculateDurationInDays(startDate, endDate);
    if (days === -1) return t('planDetail.print.errorCalculatingDuration');
    
    // Add 1 to include both start and end dates
    const totalDays = days + 1;
    return `${totalDays} ${t('planDetail.print.days')}`;
  };

  return (
    <div className="print-header mb-4">
      <h1 className="display-5 text-center mb-2">{name || t('planDetail.print.tripItinerary')}</h1>
      
      {destination && (
        <h3 className="text-center mb-3 text-secondary">
          <i className="bi bi-geo-alt me-1"></i> {destination}
        </h3>
      )}
      
      <Row className="mb-3 mt-4">
        <Col md={6} className="mb-3 mb-md-0">
          <div className="trip-dates-card">
            <h5 className="border-bottom pb-2 mb-3">{t('planDetail.print.tripDetails')}</h5>
            <p>
              <strong>{t('planDetail.print.dates')}</strong> {formatDateWithLocale(startDate, 'PPP')} - {formatDateWithLocale(endDate, 'PPP')}
            </p>
            <p>
              <strong>{t('planDetail.print.duration')}</strong> {getDuration()}
            </p>
            {groupInfo && (
              <p>
                <strong>{t('planDetail.print.travelers')}</strong> {groupInfo.numberOfPeople || t('planDetail.print.notSpecified')} 
                {groupInfo.ages && ` (${t('planDetail.overview.ages')}: ${groupInfo.ages})`}
              </p>
            )}
          </div>
        </Col>
        
        <Col md={6}>
          <div className="trip-description-card">
            <h5 className="border-bottom pb-2 mb-3">{t('planDetail.print.tripDescription')}</h5>
            {description ? (
              <div className="print-description info-content mb-0" dangerouslySetInnerHTML={{ __html: sanitizeHTML(description) }} />
            ) : (
              <p className="mb-0 text-muted">{t('planDetail.print.noDescription')}</p>
            )}
          </div>
        </Col>
      </Row>
      
      <div className="print-divider">
        <hr className="my-4" />
      </div>
    </div>
  );
};

export default PrintHeader; 